const API_BASE = import.meta.env.VITE_API_BASE_URL;

/**
 * Returns the full corrections map: { [employeeId]: { managerId?, department?, jobTitle?, topOfOrg?, updatedBy, updatedAt } }
 * Returns {} if the API is unavailable or no corrections exist.
 */
export async function getCorrections(apiToken) {
  if (!API_BASE) return {};
  try {
    const res = await fetch(`${API_BASE}/corrections`, {
      headers: apiToken ? { Authorization: `Bearer ${apiToken}` } : {},
      // Never serve corrections from the HTTP cache — a stale response here
      // makes a just-saved edit look like it reverted on the next refetch.
      cache: 'no-store',
    });
    if (!res.ok) throw new Error(`Corrections API ${res.status}`);
    return await res.json();
  } catch (err) {
    console.warn('Failed to load corrections (non-fatal):', err.message);
    return {};
  }
}

/**
 * Save a correction for one employee.
 * patch: { managerId?: string | null, department?: string | null, jobTitle?: string | null, topOfOrg?: boolean | null }
 * Pass null to a field to clear a previously saved correction.
 * Returns the updated correction entry, or null on failure.
 */
export async function setCorrection(apiToken, employeeId, patch) {
  if (!API_BASE) throw new Error('API not configured');
  const res = await fetch(`${API_BASE}/corrections/${employeeId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...(apiToken ? { Authorization: `Bearer ${apiToken}` } : {}),
    },
    body: JSON.stringify(patch),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Failed to save correction: ${res.status}${text ? ` — ${text}` : ''}`);
  }
  return await res.json();
}
